/*
 * @Author: Ximen
 * @Date: 2021-03-17 14:12:51
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-14 16:10:56
 */
import { createRouter, createWebHashHistory } from 'vue-router';
import remove from '@/untils/removeLocalStorage';
import Home from '../views/home/Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '补充资料',
    },
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录-海带云',
    },
    component: () => import(/* webpackChunkName: "login" */ '../views/login/login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '注册-海带云',
    },
    component: () => import(/* webpackChunkName: "login" */ '../views/register/register.vue'),
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    meta: {
      title: '忘记密码',
    },
    component: () => import(/* webpackChunkName: "costMode" */ '../views/forgetPassword/forgetPassword.vue'),
  },
  {
    path: '/costMode',
    name: 'costMode',
    component: () => import(/* webpackChunkName: "costMode" */ '../views/costMode/costMode.vue'),
  },
  {
    path: '/payResult',
    name: 'payResult',
    component: () => import(/* webpackChunkName: "costMode" */ '../views/payResult/payResult.vue'),
  },
  {
    path: '/paymentRecord',
    name: 'paymentRecord',
    component: () => import(/* webpackChunkName: "costMode" */ '../views/paymentRecord/paymentRecord.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title as unknown as string;
  }
  if (to.name !== 'login' && to.name !== 'register' && to.name !== 'forgetPassword') {
    if (localStorage.token) {
      next();
    } else {
      remove();
      next({ name: 'login' });
    }
  } else {
    next();
  }
});

export default router;
